// Client-side translator for subscription plan strings coming from the backend.
// Backend seeds plans in Italian ("Fino a 3 tecnici", "Magazzino generale", ...) and users
// may edit them freely, so we do a lookup on the raw text to translate common phrases.

const norm = (s) => (s || "").toString().trim().toLowerCase();

// Map: normalized italian text -> i18n key under "plans.*" that we resolve via t()
const FEATURE_KEYS = {
  "fino a 3 tecnici": "plans.up_to_3_technicians",
  "fino a 10 tecnici": "plans.up_to_10_technicians",
  "fino a 50 tecnici": "plans.up_to_50_technicians",
  "tecnici illimitati": "plans.unlimited_technicians",
  "magazzino generale": "plans.feature_general_warehouse",
  "magazzino + seriali": "plans.feature_warehouse_serials",
  "assegnazioni impianti": "plans.feature_job_assignments",
  "email smtp": "plans.feature_smtp",
  "custom smtp": "plans.feature_smtp",
  "tutto in base": "plans.everything_in_base",
  "tutto di base": "plans.everything_in_base",
  "tutto in pro": "plans.everything_in_pro",
  "tutto di pro": "plans.everything_in_pro",
  "bef & listini": "plans.feature_bef_pricelists",
  "bef e listini": "plans.feature_bef_pricelists",
  "automezzi": "plans.feature_vehicles",
  "priorità supporto": "plans.priority_support",
  "supporto prioritario": "plans.priority_support",
  "supporto email": "plans.email_support",
  "sla & supporto dedicato": "plans.dedicated_sla_support",
  "sla e supporto dedicato": "plans.dedicated_sla_support",
  "lavorazioni + bef": "plans.feature_works_bef",
  "bolle ddt con firma": "plans.feature_ddt_signature",
  "attrezzatura & dpi": "plans.feature_equipment_ppe",
  "attrezzatura e dpi": "plans.feature_equipment_ppe",
  "assegnazioni excel + smtp": "plans.feature_excel_smtp",
  "multi-sede": "plans.feature_multisite",
  "report avanzati": "plans.feature_advanced_reports",
  "api dedicate": "plans.feature_api",
  // Plan descriptions
  "perfetto per iniziare": "plans.desc_base",
  "per imprese in crescita": "plans.desc_pro",
  "per aziende strutturate": "plans.desc_business",
};

export function translatePlanText(text, t) {
  const key = FEATURE_KEYS[norm(text)];
  if (!key) return text;
  const translated = t(key);
  // If the key is missing (returns the key itself), fall back to the original text
  return translated && translated !== key ? translated : text;
}

export function translatePlanMaxTech(count, t) {
  if (!count) return null;
  if (count >= 50) return t("plans.unlimited_technicians");
  return t("plans.up_to_technicians", { count });
}
